import { useState } from "react";

export const usePersist = (key, initial) => {
  const k = `open-${key}`;
  const [v, setV] = useState(() => {
    const s = localStorage.getItem(k);
    return s === null ? initial : s === "1";
  });
  const set = (n) => {
    setV((prev) => {
      const next = typeof n === "function" ? n(prev) : n;
      localStorage.setItem(k, next ? "1" : "0");
      return next;
    });
  };
  return [v, set];
};
